import React from 'react';
import { Layout } from 'antd';

const { Footer } = Layout;

function FooterLayout() {
  return <Footer>Software Chill ©2020</Footer>;
}

export default FooterLayout;
